"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _likePostRequest = _interopRequireDefault(require("../../utils/likePostRequest"));

var _common = require("@insided/shared/utils/common");

var _axios = _interopRequireDefault(require("axios"));

var _TopicFooterContent = require("@insided/destination/modules/Content/TopicList/TopicFooterContent");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListLikeButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListLikeButton, _Component);

  var _super = _createSuper(TopicListLikeButton);

  function TopicListLikeButton() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicListLikeButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hasCurrentUserLiked: _this.props.topic.hasCurrentUserLiked,
      numberOfLikes: _this.props.topic.numberOfLikes
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "likeTopicHandler", function (isIdea) {
      var _this$props = _this.props,
          isGuest = _this$props.isGuest,
          topic = _this$props.topic;
      var id = topic.firstPost.id;
      var _this$state = _this.state,
          hasCurrentUserLiked = _this$state.hasCurrentUserLiked,
          numberOfLikes = _this$state.numberOfLikes;

      if (isGuest) {
        var event = new CustomEvent('GuestUserAction');
        return window.dispatchEvent(event);
      }

      _this.setState({
        hasCurrentUserLiked: !hasCurrentUserLiked,
        numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
      });

      if (isIdea && _common.common.isModuleActive('ideationV2')) {
        if (hasCurrentUserLiked) {
          _axios.default.post("/community/api/ideas/".concat(topic.privateId, "/unvote"));
        } else {
          _axios.default.post("/community/api/ideas/".concat(topic.privateId, "/vote"));
        }
      } else if (topic.contentType === 'productUpdate') {
        if (hasCurrentUserLiked) {
          _axios.default.post("/community/api/productUpdates/".concat(topic.privateId, "/unlike"));
        } else {
          _axios.default.post("/community/api/productUpdates/".concat(topic.privateId, "/like"));
        }
      } else {
        (0, _likePostRequest.default)(topic.id, id, !hasCurrentUserLiked, function (err) {
          if (err) {
            _this.setState({
              hasCurrentUserLiked: !hasCurrentUserLiked,
              numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
            });

            console.error(err);
          }
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TopicListLikeButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var topic = this.props.topic;
      var _this$state2 = this.state,
          hasCurrentUserLiked = _this$state2.hasCurrentUserLiked,
          numberOfLikes = _this$state2.numberOfLikes;
      var isIdea = topic.contentType === 'idea';

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var isConversation = topic.contentType === 'conversation' || topic.contentType === 'discussion';
      var showVoteButton = isIdea || isConversation && isBugContentTypeEnabled;

      if (showVoteButton) {
        return (0, _preact.h)(_TopicFooterContent.TopicVoteButtonView, {
          hasVoted: hasCurrentUserLiked,
          count: numberOfLikes,
          onClick: function onClick() {
            return _this2.likeTopicHandler(isIdea);
          }
        });
      }

      return (0, _preact.h)(_TopicFooterContent.TopicLikeButtonView, {
        hasVoted: hasCurrentUserLiked,
        count: numberOfLikes,
        onClick: function onClick() {
          return _this2.likeTopicHandler(isIdea);
        }
      });
    }
  }]);
  return TopicListLikeButton;
}(_preact.Component);

exports.default = TopicListLikeButton;